import {
  get,
  post,
} from '.';

export const getUsers = () => get('/users');
export const getUser = userId => get(`/users/${userId}`);
export const postUserContact = (userId, body) => post(`/users/${userId}/contact`, { body });
